import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';

import { Contact } from '../../core/models/contact';
import { ContactService } from '../../core/services/contact.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  contact: Contact = {
    name: '',
    email: '',
    mobile: '',
    subject: '',
    sourceSystemId: null,
    message: ''
  };

  isSending = false;
  successMessage = '';
  errorMessage = '';

  constructor(
    private titleService: Title,
    private contactService: ContactService
  ) {}

  ngOnInit(): void {
    this.titleService.setTitle('Aldawal - Contact');
  }

  sendMessage(contactForm: NgForm): void {
    this.successMessage = '';
    this.errorMessage = '';

    if (contactForm.invalid) {
      contactForm.control.markAllAsTouched();
      return;
    }

    this.isSending = true;

    const request: Contact = {
      name: this.contact.name.trim(),
      email: this.contact.email.trim(),
      mobile: this.contact.mobile.trim(),
      subject: this.contact.subject.trim(),
      sourceSystemId: 1,
      message: this.contact.message.trim()
    };

    this.contactService
      .sendContactMessage(request)
      .pipe(
        finalize(() => {
          this.isSending = false;
        })
      )
      .subscribe({
        next: () => {
          this.successMessage =
            'تم إرسال رسالتك بنجاح، وسيتم التواصل معك قريباً.';

          contactForm.resetForm();

          this.contact = {
            name: '',
            email: '',
            mobile: '',
            subject: '',
            sourceSystemId: null,
            message: ''
          };
        },
        error: error => {
          console.error('Contact API error:', error);

          this.errorMessage =
            error?.error?.message ||
            error?.error?.title ||
            'حدث خطأ أثناء إرسال الرسالة، برجاء المحاولة مرة أخرى.';
        }
      });
  }
}